export const convertSecondsToHours = (seconds: number, fraction = 1) => {
  if (!seconds || fraction === 0) return 0

  const hours = Math.round(Number((seconds / 3600) * fraction)) / fraction

  if (hours === 0) return 1

  return hours
}
